import type { i18n as I18nInstance, TOptions } from 'i18next';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locale/en.json';
import es from '../locale/es.json';
import ru from '../locale/ru.json';

function splitLocale(locale: typeof en): { filters: Omit<typeof en, 'Labels'>; Labels: typeof en.Labels } {
  const { Labels, ...filters } = locale;
  return { filters, Labels };
}

const enResources = splitLocale(en);
const ruResources = splitLocale(ru);
const esResources = splitLocale(es);

export function createFiltersI18n(parentI18n?: I18nInstance): I18nInstance {
  const instance = i18next.createInstance();

  instance.use(initReactI18next).init({
    resources: {
      en: enResources,
      ru: ruResources,
      es: esResources,
    },
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'filters',
    interpolation: {
      escapeValue: false,
    },
  });

  if (parentI18n) {
    const originalT = instance.t.bind(instance);

    instance.t = ((key: unknown, options?: TOptions | string) => {
      const keyStr = Array.isArray(key) ? String(key[0]) : String(key);
      const isExternalNs = keyStr.includes(':') && !keyStr.startsWith('filters:');

      // Prefer host Labels/common/wellsFilter when available; package Labels are fallback.
      if (isExternalNs && parentI18n.exists(keyStr)) {
        return parentI18n.t(keyStr, options as TOptions);
      }

      if (instance.exists(keyStr)) {
        return originalT(key as never, options as never);
      }

      if (parentI18n.exists(keyStr)) {
        return parentI18n.t(keyStr, options as TOptions);
      }

      return originalT(key as never, options as never);
    }) as typeof instance.t;
  }

  return instance;
}
